import { AddressDTO, MessageDTO } from '../../../types';
import { QueryBuilder } from '../../../utils';

export enum TripState {
  PLAYING = 'PLAYING',
  PAUSED = 'PAUSED',
  INITIAL = 'INITIAL',
}

export interface TripsFilterDTO {
  startDate: string;
  endDate?: string;
  transportId: number;
  limit?: number;
  exactTripID?: string;
  includeMessages: boolean;
}

export interface IMessageEvent extends MessageDTO {
  code: MessageEventType;
  id: string;
}

export interface TripDTO {
  id: number;
  deviceId: number;
  transportId: number;
  startTime: string;
  endTime: string;
  startLatitude: number;
  startLongitude: number;
  endLongitude: number;
  endLatitude: number;
  startAddress?: AddressDTO;
  endAddress?: AddressDTO;
  distance: number;
  messages?: Array<MessageDTO>;
  events?: Array<IMessageEvent>;
  timestamp?: number;
}

export enum MessageEventType {
  STOP_TIME = 'STOP_TIME',
  OVER_SPEEDING = 'OVER_SPEEDING',
  HARSH_ACCELERATION = 'HARSH_ACCELERATION',
  PARKING = 'PARKING',
  HARSH_BRAKING = 'HARSH_BRAKING',
  TEMPERATURE = 'TEMPERATURE',
  RPM_LIMIT = 'RPM_LIMIT',
}

export interface OverallTrip {
  startTime: string;
  endTime: string;
  startLatitude: number;
  startLongitude: number;
  endLongitude: number;
  endLatitude: number;
  startAddress?: AddressDTO;
  endAddress?: AddressDTO;
  distance: number;
  messages?: Array<MessageDTO>;
  events: Array<IMessageEvent>;
}

export interface TripFilter {
  query: QueryBuilder;
  includeMessages: boolean;
}

export interface TripSlice {
  all: Array<TripDTO>;
  overallTrip: OverallTrip | null;
  tripState: TripState;
  tripProgress: number;
  tripSpeed: number;
  loading: boolean;
  ENABLED_EVENT_CONTROLS: MessageEventType[];
}

export enum ReportChartOption {
  'SPEED' = 'speed',
  'TEMPERATURE' = 'temperature',
  'RELIEF' = 'altitude',
  'GSM_SIGNAL' = 'gsmSignal',
  'GPS_SIGNAL' = 'satellites',
  'VOLTAGE' = 'externalVoltage',
}
